.ux-cookie-layer-footer {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
    border-top: 1px solid var(--ux-cookie-layer-separator-color);
    padding: 30px;

    .ux-cookie-layer__button,
    .ux-cookie-layer__link {
        flex: 1 0 auto;
    }

    .ux-cookie-layer__link {
        display: flex;
        align-items: center;
        justify-content: center;

        .ux-cookie-layer__nav-item {
            color: var(--ux-cookie-layer-link-color);
            transition: var(--ux-cookie-layer-link-transition);
            text-transform: none;
            text-decoration: none;
            font-size: var(--ux-cookie-layer-font-size-normal);
        }

        .ux-cookie-layer__nav-item:hover {
            color: var(--ux-cookie-layer-link-hover-color);
            text-decoration: none;
        }
    }

    &__spacer {
        flex: 0 0 15px;
    }

    @media (min-width: $breakpoint-mobile) {
        flex-direction: row;
        flex-wrap: nowrap;

        .ux-cookie-layer__button,
        .ux-cookie-layer__link {
            flex: 1 1 50%;
        }

        &__spacer {
            flex: 0 0 30px;
        }
    }
}
